
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "add", function () { return $48d67d6d585a4b28$export$e16d8520af44a096; });
$parcel$export(module.exports, "remove", function () { return $48d67d6d585a4b28$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "fromArray", function () { return $48d67d6d585a4b28$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "toArray", function () { return $48d67d6d585a4b28$export$45b10814cc054894; });
$parcel$export(module.exports, "equals", function () { return $48d67d6d585a4b28$export$e9bab7fafb253603; });
$parcel$export(module.exports, "includes", function () { return $48d67d6d585a4b28$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "excludes", function () { return $48d67d6d585a4b28$export$7aa856f34ebb45f2; });
$parcel$export(module.exports, "noneOf", function () { return $48d67d6d585a4b28$export$2a75fb877f753830; });
const $48d67d6d585a4b28$export$e16d8520af44a096 = (mask, flags)=>{
    if (mask === undefined || mask === null) mask = 0;
    const flagsArr = Array.isArray(flags) ? flags : [
        flags
    ];
    return flagsArr.reduce((acc, f)=>acc | f, mask);
};
const $48d67d6d585a4b28$export$cd7f480d6b8286c3 = (mask, flags)=>{
    if (mask === undefined || mask === null) return 0;
    const flagsArr = Array.isArray(flags) ? flags : [
        flags
    ];
    return flagsArr.reduce((acc, f)=>acc & ~f, mask);
};
const $48d67d6d585a4b28$export$571d59b505e6bb4e = (flags)=>$48d67d6d585a4b28$export$e16d8520af44a096(0, flags);
const $48d67d6d585a4b28$export$45b10814cc054894 = (mask)=>{
    if (mask === undefined || mask === null) return [];
    return mask.toString(2).split("").reverse().reduce((acc, v)=>{
        acc.push(+v * Math.pow(2, acc.length));
        return acc;
    }, []).filter((v)=>v);
};
const $48d67d6d585a4b28$export$e9bab7fafb253603 = (mask, flags)=>{
    if (mask === undefined || mask === null) return false;
    const comparable = $48d67d6d585a4b28$export$571d59b505e6bb4e(flags);
    return mask === comparable;
};
const $48d67d6d585a4b28$export$ee2e0f811dca1807 = (mask, flags)=>{
    if (mask === undefined || mask === null) return false;
    const comparable = $48d67d6d585a4b28$export$571d59b505e6bb4e(flags);
    return (mask & comparable) === comparable;
};
const $48d67d6d585a4b28$export$7aa856f34ebb45f2 = (mask, flags)=>{
    if (mask === undefined || mask === null) return false;
    return !$48d67d6d585a4b28$export$ee2e0f811dca1807(mask, flags);
};
const $48d67d6d585a4b28$export$2a75fb877f753830 = (mask, flags)=>{
    if (mask === undefined || mask === null) return false;
    const comparable = $48d67d6d585a4b28$export$571d59b505e6bb4e(flags);
    if (mask === 0 && comparable === 0) return false;
    return (mask & comparable) === 0;
};


//# sourceMappingURL=browser.js.map
